export var isValidateResult = function (obj) {
    return !!obj['type'] && !!obj['message'];
};
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/validator/esm/types.js
// module id = null
// module chunks = 